import styled from "styled-components"
import { device, media } from "../../theme"

const Wrapper = styled.div`
display: flex;
  &.row-center {
    justify-content: center;
  }

  > *:not(:first-child) {
    margin-left: 1rem;
  }

  &.row-wrap {
    ${media.down(device.tablet)`
      flex-direction: column;
      > * {
        width: 100%;
        margin: 0.75rem 0;
        display: flex;
        justify-content: center;
      }
      > * {
        margin-left: 0;
      }
    `}
  }
  `

const FormRow = (props) => {
  const { label, hint, errorMessage, required, children, className, center, noWrap } = props

  const classNames = ['formRow']
  if (className) classNames.push(className)

  if (required) {
    classNames.push('formRow--required')
  }
  if (errorMessage) {
    classNames.push('formRow--error')
  }
  if (center) {
    classNames.push('row-center')
  }
  if (!noWrap) {
    classNames.push('row-wrap')
  }



  return (
    <Wrapper className={classNames.join(' ')}>
      {label && <label className="formRow__label">{label}</label>}
      <div className="formRow__control">{children}</div>
      {hint && <div className="formRow__hint">{hint}</div>}
      {errorMessage && (
        <div className="formRow__errorMessage">{errorMessage}</div>
      )}
    </Wrapper>
  )
}

export default FormRow
